export default "__VITE_ASSET__CtlnzoSf__"